import { useCallback } from 'react'
import { throttle } from 'lodash'

export const useThrottle = (cb, delay=1000, cbDependencies=[]) => { 
  return useCallback(
    throttle(cb, delay, { leading: true, trailing: false }),
    cbDependencies
  )  
}
